<template>
  <div class="app-container">
    <div class="page-title">
      <h2>{{ $t('superviseur.equipe.title') }}</h2>
    </div>

    <el-card class="box-card">
      <div class="filter-container">
        <el-select
          v-model="query.campagne_agricole_id"
          class="mr-15 filter-item"
          style="width: 220px;"
          :placeholder="$t('recolte.campagne')"
          @change="loadEquipe"
        >
          <el-option
            v-for="campagne in campagnes"
            :key="campagne.id"
            :label="campagne.nom"
            :value="campagne.id"
          />
        </el-select>
      </div>

      <el-table v-loading="loading" :data="list" border fit highlight-current-row style="width: 100%">
        <el-table-column align="center" :label="$t('general.code')" prop="code" width="100" />
        <el-table-column align="center" :label="$t('controleur.controleur')" prop="nom" min-width="160" />
        <el-table-column align="center" :label="$t('superviseur.equipe.up')" prop="unite_production" min-width="140" />
        <el-table-column align="center" :label="$t('superviseur.equipe.groupements')" prop="groupements_count" width="110" />
        <el-table-column align="center" :label="$t('superviseur.equipe.ciTermines')" prop="ci_termines" width="100" />
        <el-table-column align="center" :label="$t('superviseur.equipe.ciEnAttente')" prop="ci_en_attente" width="110" />
        <el-table-column align="center" :label="$t('superviseur.types.formation')" prop="formations" width="100" />
        <el-table-column align="center" :label="$t('superviseur.types.audit')" prop="audits" width="90" />
        <el-table-column align="center" :label="$t('superviseur.equipe.derniereActivite')" min-width="150">
          <template slot-scope="scope">
            <span>{{ formatDate(scope.row.derniere_activite) }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import Resource from '@/api/resource';
import { getSuperviseurControleurs } from '@/api/superviseur';

const campagneResource = new Resource('campagne_agricoles');

export default {
  name: 'SuperviseurEquipe',
  data() {
    return {
      list: [],
      campagnes: [],
      loading: false,
      query: {
        campagne_agricole_id: null,
      },
    };
  },
  created() {
    this.loadCampagnes();
  },
  methods: {
    formatDate(value) {
      if (!value) {
        return '—';
      }
      const date = new Date(value);
      return Number.isNaN(date.getTime()) ? value : date.toLocaleString();
    },
    async loadCampagnes() {
      const { data } = await campagneResource.list({ limit: 100 });
      this.campagnes = data || [];
      try {
        const { data: current } = await campagneResource.sublist('/en_cours');
        this.query.campagne_agricole_id = current && current.id ? current.id : (this.campagnes[0] ? this.campagnes[0].id : null);
      } catch (error) {
        this.query.campagne_agricole_id = this.campagnes[0] ? this.campagnes[0].id : null;
      }
      this.loadEquipe();
    },
    async loadEquipe() {
      this.loading = true;
      try {
        const response = await getSuperviseurControleurs(this.query);
        this.list = response.data || [];
      } catch (error) {
        console.error(error);
        this.$message.error(this.$t('general.errorOccurred'));
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
